module.exports = __webpack_public_path__ + "static/media/preview_escargable_2.1bc648be.png";